const risingRiskPageMessages = {
  RISING_RISK_PAGE: {
    TITLE: 'Disease Prognosis',
    SUBTITLE: {
      PART1:
        'Members on an intensifying disease progression, who may have a diagnosis in the next 12-24 months, and those members already with a diagnosis.  A focus on rising risk can prevent the onset of disease and the costly treatments associated with it.',
    },
    SUMMARY_CARDS: {
      AVG_RISK: 'Avg Risk Score',
      LATENT_RISK: 'Rising Risk Members',
      CHRONIC_DIAGNOSED: 'Chronic Diagnosed',
      ACUTE_DIAGNOSED: 'Acute Diagnosed',
    },
    DISEASES_SUMMARY_CARDS: {
      RISK_PROBABILITY: 'Risk Probability',
      LATENT_RISK: 'Rising Risk Members',
      CHRONIC_DIAGNOSED: 'Chronic Diagnosed',
      ACUTE_DIAGNOSED: 'Acute Diagnosed',
    },
    DISEASES: 'Diseases',
    DISEASES_CARD_SUBTITLE: 'Click on a Risk to view more info',
    DISEASES_DESCRIPTION_SUBTITLE:
      'Detail on members progressing toward a specific diagnosis, including common trends present in this particular population.',
    TOP_CONDITIONS: {
      TITLE: 'Top Conditions by ',
      SUB_TITLE: 'Showing top Conditions',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    TOP_MEDICATIONS: {
      TITLE: 'Top Medications by ',
      SUB_TITLE: 'Showing top Medications (including infused drugs)',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
    TOP_PROCEDURES: {
      TITLE: 'Top Procedures by ',
      SUB_TITLE: 'Showing top Procedures',
      DROPDOWN_OPTIONS: ['Member', 'Cost'],
    },
  },
};

export default risingRiskPageMessages;
